module.exports = __webpack_public_path__ + "img/about-5.f3964be1.jpg";